
export default {
  layout: 'empty',
  props: {
    error: {
      type: Object,
      default: null,
    },
  },
  head() {
    const title = this.error.statusCode === 404 ? this.$t('error.notFound') : this.$t('error.errorTitle')
    return { title }
  },
}
